export const getKindDescription = (kind) => {
  if (kind !== null && kind !== '') {
    return `${kind} `;
  }

  return 'Event   ';
};
